import React, { createContext } from "react";

export const AppContext = createContext({});
